import {FormGroup} from '@angular/forms';
import {Component, forwardRef, Inject, Input} from '@angular/core';
import {FilterFieldAbstract} from './filter-field.abstract';
import {FilterDirective} from './container/filter.directive';

@Component({
    selector: 'tfl-filter-field-select',
    template: `
        <div [formGroup]="formGroup" [ngClass]="getFormGroupClasses()">
            <label [for]="id" [ngClass]="getFormLabelClasses()">
                {{ label | translate }}:
            </label>

            <div [ngClass]="getFormControlClasses()">
                <select [id]="id" [name]="id" class="form-control" [formControlName]="controlName" [compareWith]="sameValue">
                    <!-- TODO on select -> reset -->
                    <option [ngValue]="defValue">
                        {{ 'COMMON.SHOW_ALL' | translate }}
                    </option>

                    <option *ngFor="let item of values" [ngValue]="getKey(item)">
                        {{ getName(item) | translate }}
                    </option>
                </select>
            </div>
        </div>
    `
})
export class FilterFieldSelectComponent extends FilterFieldAbstract {

    @Input('id') id: string;
    @Input('label') label: string;

    @Input('values') values: any[] = [];
    @Input('keyName') keyName: string = 'id';
    @Input('valueName') valueName: string = 'name';

    @Input('formGroup') formGroup: FormGroup;
    @Input('controlName') controlName: string;
    @Input('defValue') defValue: any;

    protected filter: FilterDirective;

    constructor(@Inject(forwardRef(() => FilterDirective)) filter: FilterDirective) {
        super();
        this.filter = filter;
    }

    // reset() {
    //     let control: AbstractControl = this.formGroup.controls[this.controlName];
    //     if (!!control) setTimeout(() => {
    //         console.info('CLEAR');
    //         control.reset(this.defValue);
    //     }, 100)
    // }

    /** A reset control is null and "Show all" is undefined: treat both as empty, or the select shows a blank option. */
    sameValue(a: any, b: any): boolean {
        return a === b || (a == null && b == null) || (a !== a && b !== b);
    }

    getKey(item) {
        return item && item[this.keyName]
    }

    getName(item) {
        return item && item[this.valueName]
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/filter/filter-field-select.component.ts